import {
  EXTRACTED_TABLES_REQUEST,
  EXTRACTED_TABLES_SUCCESS,
  EXTRACTED_TABLES_FAILURE,
} from "../types/extractedTables.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const ExtractedTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXTRACTED_TABLES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EXTRACTED_TABLES_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case EXTRACTED_TABLES_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default ExtractedTablesReducer;
